// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import {
  BottomNavigationAction as MuiBottomNavigationAction,
  bottomNavigationActionClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledBottomNavigationAction = styled(MuiBottomNavigationAction)(
  ({ theme: { palette } }) => ({
    [`&.${bottomNavigationActionClasses.selected}`]: {
      color: palette.primary.main,
      [`& .${bottomNavigationActionClasses.label}`]: {
        color: palette.primary.main,
      },
    },
  })
);

function BottomNavigationAction(props) {
  return <StyledBottomNavigationAction {...props} />;
}

export default BottomNavigationAction;
